import { render } from "./CrouselComponent.vue?vue&type=template&id=45d2066b"
import script from "./CrouselComponent.vue?vue&type=script&lang=js"
export * from "./CrouselComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__